import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { ScopeLogo } from '@assets';

import importedStyles from './ErrorPage.module.css';

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fallback: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  } as React.CSSProperties,
  buttonStyle: {
    backgroundColor: `rgba(23,23,23,0.1)`,
    '&:hover': {
      color: `rgba(23,23,23,1)`,
    },
  },
};

export const ErrorPage = () => {
  const router = useRouter();
  const { eventId } = router.query;

  useEffect(() => {
    setTimeout(
      () => router.push(eventId ? `/event/${eventId}` : '/error'),
      5000
    );
  }, [eventId, router]);

  return (
    <>
      <Head>
        <title>Scope Tickets</title>
      </Head>

      <div className='wrapper'>
        <div className='container' style={styles.container}>
          <div className='fallback' style={styles.fallback}>
            <ScopeLogo
              fill='#0500F2'
              style={{
                height: '60px',
                padding: '20px',
                marginBottom: '20px',
              }}
            />
            <h1>
              Your session expired. If you are not redirected in 5 seconds click
              the button below
            </h1>
            <Link href={eventId ? `/event/${eventId}` : '/error'}>
              <a className={importedStyles.errorButton}>
                <p>Reload</p>
              </a>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
